<template>
  <div class="order-card order-card--ebook dea-border-grey-medium">
    <div class="order-card__header order-card__header--ebook">
      <h2 class="dea-heading--medium__m">Numero d'ordine: {{ order.external_id }}</h2>
      <span class="dea-heading--light-s">{{ order.created }}</span>
    </div>
    <div v-if="orderExpired" class="order-card__badge-container--ebook">
      <Badge class="dea-heading--regular__xxs dea-bg-feedback-red-negative">
        Scaduto il: {{ order.expire_date }}
      </Badge>
    </div>
    <div class="order-card__registrations-list--ebook">
      <div v-for="(item, index) in order.items" :key="index" class="order-card__registration">
        <div class="order-card__registration-ebook-info">
          <div class="order-card__registration-ebook-image">
            <img :src="item.work.cover_url" :alt="item.work.title" />
          </div>
          <div class="order-card__registration-ebook-text">
            <div class="order-card__registration-ebook-title dea-heading--regular-m">{{ item.work.title }}</div>
            <div class="order-card__registration-subtitle">
              <div class="dea-heading--light-xs">{{ item.title }}</div>
              <div class="dea-heading--upper-xxxs order-card__registration-subtitle-isbn-title">CODICE ISBN</div>
              <div class="dea-heading--light-xs order-card__registration-subtitle-isbn-code">{{ item.isbn }}</div>
            </div>
          </div>
        </div>
        <div class="order-card__registration-price dea-heading--medium__s">
          {{
            item.product_total_price != 0 && item.product_total_price !== null
              ? `${item.product_total_price} €`
              : "free"
          }}
        </div>
      </div>
    </div>
    <div class="order-card__footer">
      <div class="order-card__badge-container-footer">
        <Badge v-if="order.is_paid" class="dea-heading--regular__xxs dea-bg-feedback-green-positive"> Pagato </Badge>
        <Badge v-else class="dea-heading--regular__xxs dea-bg-feedback-red-negative"> Annullato </Badge>
      </div>
      <div class="order-card__price-container-footer">
        <div class="dea-heading--light-s">TOTALE</div>
        <div class="dea-heading--medium__s">
          {{ order.total_price != 0 && order.total_price !== null ? `${order.total_price} €` : "free" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/elements/Badge";

export default {
  name: "CardOrderEbook",
  components: { Badge },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    orderExpired() {
      if (this.order.expire_date) {
        const dateParts = this.order.expire_date.split("/");
        const expirationDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        return expirationDate < new Date();
      }
      return null;
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

$item-price-min-width: 70px;

.order-card--ebook {
  .order-card__header--ebook {
    margin-bottom: 0;
  }

  .order-card__badge-container--ebook {
    margin-top: $space-x-small;
    text-align: right;
  }

  .order-card__registrations-list--ebook {
    margin-top: $space-base;

    .order-card__registration {
      align-items: flex-start;
      justify-content: space-between;

      &-ebook-info {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
      }

      &-ebook-image {
        margin-right: $space-xm-small;

        img {
          width: $space-x-large;
        }
      }

      &-ebook-text {
        display: flex;
        flex-direction: column;
      }

      &-price {
        @include media("<=xs") {
          margin-left: 0;
          text-align: left;
        }

        margin-left: $space-x-small;
        min-width: $item-price-min-width;
        text-align: right;
      }
    }
  }

  .order-card__registration-subtitle-isbn-title {
    margin-bottom: $space-xx-small;
    margin-top: $space-x-small;
  }

  .order-card__footer {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
